import type { IconSvgObject } from './types';

const Building05Icon: IconSvgObject = [
  ["path", { d: "M2.00018 22H22.0002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 22V11C21 9.89543 20.1046 9 19 9H13C11.8954 9 11 9.89543 11 11V22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 22V4C3 2.89543 3.89543 2 5 2H13C14.1046 2 15 2.89543 15 4V9", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3 6H6M3 10H6M3 14H6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M15.0002 13H17.0002M15.0002 16H17.0002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M16.0002 22L16.0002 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "5" }]
];

export default Building05Icon;
